import practicesHooks from './hooks'
import PracticesAssessments from './PracticesAssessments'

export { practicesHooks }
export default PracticesAssessments